<div>
    <div class="plan-options-individual" style="border:1px solid #f2f2f2;" *ngIf="data">
        <img class="plan-options-image" src="assets/images/audi-rings.svg" width="150px;" alt="logo" /> <br />
        <app-audi-text variant="order4" className="audi-type-normal" weight="bold" text="R{{data.price | number}} (incl. VAT)">
        </app-audi-text><br />
        <app-audi-text text="{{data.planType}} - {{data.years}} Years - {{data.maxKilometers}} KM" variant="copy1">
        </app-audi-text>
        <div style="margin-top:10px;">
            <app-audi-button text="{{buttonText}}" (click)="viewQuote()" [disabled]="data?.price <= 0">
            </app-audi-button>
        </div>
    </div>
</div>